var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings",style:(_vm.isMobile && _vm.currentTab ? 'height: 100% !important;' : '')},[(_vm.showSettingsMenu)?_c('SettingsMenu'):_vm._e(),_c('div',{staticClass:"settings__separator"}),(_vm.showSettingsArea)?_c('SettingsArea'):_vm._e(),(!_vm.isMobile)?_c('SettingsCloseButton'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }